import {
  css, CSSResult, html, LitElement, PropertyValues, unsafeCSS,
} from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import styles from './options.scss';

@customElement('ents-options')
export class Options extends LitElement {
  @state()
  private isSticky: boolean = false;

  @state()
  private layerOpen: boolean = false;

  static get styles(): CSSResult {
    return css`${unsafeCSS(styles)}`;
  }

  protected render(): unknown {
    return html`
      <div class="ents-options ${classMap({ 'ents-options--sticky': this.isSticky, 'ents-options--layer-open': this.layerOpen })}">
        <div class="ents-options__spacer"></div>
        <slot
          @ents-layer-opened="${this.onLayerOpened}"
          @ents-layer-closed="${this.onLayerClosed}"
        ></slot>
      </div>
    `;
  }

  private onLayerOpened() {
    this.layerOpen = true;
  }

  private onLayerClosed() {
    this.layerOpen = false;
  }

  protected firstUpdated(_changedProperties: PropertyValues) {
    super.firstUpdated(_changedProperties);

    const observer = new IntersectionObserver(
      ([e]) => {
        this.isSticky = e.intersectionRatio < 1;
      },
      { threshold: [1] },
    );

    observer.observe(this);
  }
}
